<template>
  <div class="inventory-list-container">
    <h2 class="page-title">公司货盘管理</h2>

    <!-- 查询表单 -->
    <div class="search-form">
      <div class="search-row">
        <div class="search-col">
          <div class="form-group">
            <label for="productName">产品名称</label>
            <el-input id="productName" v-model="search.productName" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="sku">SKU</label>
            <el-input id="sku" v-model="search.sku" placeholder="模糊查询" :disabled="loading"></el-input>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="warehouse">仓库</label>
            <el-select id="warehouse" v-model="search.warehouse" placeholder="请选择仓库" :disabled="loading" style="width: 100%" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="加纳" value="GH01"></el-option>
              <el-option label="肯尼亚" value="KE01"></el-option>
              <el-option label="乌干达" value="UG01"></el-option>
              <el-option label="尼日利亚" value="NG01"></el-option>
              <el-option label="巴基斯坦" value="PK02"></el-option>
            </el-select>
          </div>
        </div>
      </div>
      <div class="search-row">
        <div class="search-col" v-if="isAdminUser">
          <div class="form-group">
            <label for="palletStatus">是否货盘</label>
            <el-select id="palletStatus" v-model="search.palletStatus" placeholder="请选择" :disabled="loading" style="width: 100%" clearable>
              <el-option label="全部" value=""></el-option>
              <el-option label="是" value="1"></el-option>
              <el-option label="否" value="0"></el-option>
            </el-select>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="startDate">上新开始日期</label>
            <el-date-picker
              id="startDate"
              v-model="search.startDate"
              type="date"
              placeholder="选择日期"
              :disabled="loading"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="search-col">
          <div class="form-group">
            <label for="endDate">上新结束日期</label>
            <el-date-picker
              id="endDate"
              v-model="search.endDate"
              type="date"
              placeholder="选择日期"
              :disabled="loading"
              style="width: 100%"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </div>
        </div>
        <div class="search-col search-button-col">
          <el-button type="primary" @click="handleSearch" :disabled="loading" :loading="loading">
            查询
          </el-button>
        </div>
      </div>
    </div>

    <!-- 库存表格 -->
    <div class="table-container">
      <table>
      <thead class="sticky-header">
        <tr>
          <th style="width: 10%">SKU</th>
          <th style="width: 8%">产品图片</th>
          <th  v-if="isAdminUser" style="width: 10%">当前归属人</th>
          <th style="width: 12%">产品中文名</th>
          <th style="width: 8%">仓库</th>
          <th style="width: 8%">在途</th>
          <th style="width: 8%">可售数量</th>
          <th style="width: 8%">已出库</th>
          <th style="width: 10%">产品货值</th>
          <th style="width: 10%">投放视频</th>
          <th style="width: 8%">产品定位</th>
          <th v-if="isAdminUser" style="width: 8%">是否货盘</th>
          <th v-if="isAdminUser" style="width: 8%">最大库龄</th>
          <th style="width: 12%">上新时间</th>
          <th v-if="isAdminUser" style="width: 8%">操作</th>
        </tr>
      </thead>
        <tbody>
          <!-- 加载中状态 -->
          <tr v-if="loading">
            <td colspan="15" style="text-align: center; padding: 20px;">
              <span v-if="$loading">
                <el-icon>
                  <Loading />
                </el-icon> 加载中...
              </span>
              <span v-else>加载中...</span>
            </td>
          </tr>

          <!-- 错误状态 -->
          <tr v-else-if="error">
            <td colspan="15" style="text-align: center; padding: 20px; color: #f56c6c;">
              {{ error }}
            </td>
          </tr>

          <!-- 无数据状态 -->
          <tr v-else-if="!hasData">
            <td colspan="15" style="text-align: center; padding: 20px;">
              暂无数据
            </td>
          </tr>

        <!-- 数据列表 -->
        <tr v-else v-for="item in inventoryList" :key="item.sku + '-' + item.warehouse">
          <td>{{ item.sku || '-' }}</td>
          <td>
            <img 
              v-if="item.pic" 
              :src="item.pic" 
              alt="产品图片" 
              class="product-image"
              @error="handleImageError($event)"
            >
            <span v-else>-</span>
          </td>
          <td  v-if="isAdminUser">{{ item.salesman || '-' }}</td>
          <td>{{ item.skuName || '-' }}</td>
          <td>{{ formatWarehouse(item.warehouse) }}</td>
          <td>{{ item.onway || 0 }}</td>
          <td>{{ item.sellable || 0 }}</td>
          <td>{{ item.shipped || 0 }}</td>
          <td>{{ formatProductValue(item.productModelMore) }}</td>
          <td>
            <a 
              v-if="item.videoUrl" 
              @click.prevent="downloadVideo(item.videoUrl)" 
              href="#" 
              class="video-link"
            >
              下载视频
            </a>
            <span v-else>-</span>
          </td>
          <td>
            <div class="positioning-list">
              <div v-for="(position, index) in formatPositioningList(item.positioningList)" 
                   :key="index" 
                   class="position-tag"
              >
                {{ position }}
              </div>
            </div>
          </td>
          <td v-if="isAdminUser">{{ formatPalletStatus(item.palletStatus) }}</td>
          <td v-if="isAdminUser">{{ item.maxStockAge || 0 }}</td>
          <td>{{ formatDate(item.modifyTime) }}</td>
          <td v-if="isAdminUser">
            <el-button
              type="primary"
              size="small"
              @click="openEditDialog(item)"
            >
              编辑
            </el-button>
          </td>
        </tr>
        </tbody>
      </table>

      <!-- 分页控件 -->
      <div class="pagination-container" v-if="hasData">
        <div class="page-size-selector">
          <span>每页显示：</span>
          <el-select v-model="pagination.pageSize" @change="handlePageSizeChange" :disabled="loading" size="small" style="width: 100px">
            <el-option label="10条" value="10"></el-option>
            <el-option label="100条" value="100"></el-option>
            <el-option label="1000条" value="1000"></el-option>
          </el-select>
        </div>
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          :total="pagination.totalItems"
          layout="total, prev, pager, next, jumper"
          :page-count="pagination.totalPages"
        >
        </el-pagination>
        <div class="pagination-info">
          <span>显示 {{ pagination.startIndex }}-{{ pagination.endIndex }} 条，共 {{ pagination.totalItems }} 条</span>
        </div>
      </div>
    </div>

    <!-- 悬浮滚动按钮 -->
    <div class="scroll-buttons">
      <button class="scroll-btn scroll-to-top" @click="scrollToTop" title="回到顶部">
        <i class="el-icon-arrow-up"></i>
      </button>
      <button class="scroll-btn scroll-to-bottom" @click="scrollToBottom" title="跳转到底部">
        <i class="el-icon-arrow-down"></i>
      </button>
    </div>

    <!-- 编辑弹窗 -->
    <div v-if="showEditDialog" class="dialog-overlay" @click.self="closeEditDialog">
      <div class="dialog-content">
        <div class="dialog-header">
          <h3>编辑商品信息 - {{ currentEditItem.sku }}</h3>
          <button class="close-btn" @click="closeEditDialog">×</button>
        </div>
        <div class="dialog-body">
          <div class="edit-form">
            <div class="form-group">
              <label>是否货盘</label>
              <el-radio-group v-model="editForm.palletStatus">
                <el-radio label="1">是对外货盘</el-radio>
                <el-radio label="0">否</el-radio>
              </el-radio-group>
            </div>
            <div class="form-group">
              <label>产品定位</label>
              <el-checkbox-group v-model="editForm.positioningList">
                <el-checkbox label="2">待定</el-checkbox>
                <el-checkbox label="4">引流款</el-checkbox>
                <el-checkbox label="8">稳定款</el-checkbox>
              </el-checkbox-group>
            </div>
          </div>
        </div>
        <div class="dialog-footer">
          <button @click="closeEditDialog" :disabled="saving">取消</button>
          <button @click="saveEdit" :disabled="saving" :loading="saving" type="primary">保存</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InventoryList',
  data() {
    return {
      search: {
        productName: '',
        sku: '',
        warehouse: '',
        palletStatus: '',
        startDate: '',
        endDate: ''
      },
      inventoryList: [],
      loading: false,
      error: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        totalItems: 0,
        totalPages: 0,
        pages: [],
        startPage: 0,
        endPage: 0
      },
      // 编辑相关
      showEditDialog: false,
      saving: false,
      currentEditItem: {},
      editForm: {
        palletStatus: '',
        positioningList: []
      }
    }
  },
  computed: {
    hasData() {
      return this.inventoryList && this.inventoryList.length > 0
    },
    isAdminUser() {
      try {
        const userInfoStr = localStorage.getItem('userInfo')
        if (userInfoStr) {
          const userInfo = JSON.parse(userInfoStr)
          return userInfo.isAdmin === true || userInfo.roleType === 1;
        }
        return false
      } catch (error) {
        console.error('解析用户信息失败:', error)
        return false
      }
    }
  },
  created() {
    this.fetchInventoryData()
  },
  methods: {
    /**
     * 查询库存数据
     */
    handleSearch() {
      this.pagination.currentPage = 1
      this.fetchInventoryData()
    },
    
    /**
     * 获取库存数据
     */
    fetchInventoryData() {
      this.loading = true
      this.error = null

      const requestData = {
        ...this.search,
        page: this.pagination.currentPage,
        pageSize: this.pagination.pageSize
      }

      // 移除空字符串值
      Object.keys(requestData).forEach(key => {
        if (requestData[key] === null || requestData[key] === undefined || requestData[key] === '') {
          delete requestData[key]
        }
      })

      this.axios.post('/data-serv/inventory/list', requestData)
        .then(response => {
          if (response.data.code === 0 && response.data.data) {
            const data = response.data.data
            this.pagination.totalItems = data.totalRows || 0
            this.pagination.totalPages = Math.ceil(this.pagination.totalItems / this.pagination.pageSize)
            this.inventoryList = data.list || []

            // 计算分页显示范围
            this.calculatePagination()
          } else {
            throw new Error(response.data.message || '获取库存数据失败')
          }
        })
        .catch(error => {
          console.error('获取库存数据失败:', error)
          this.error = error.message || '获取库存数据失败'
          this.inventoryList = []
          this.pagination.totalItems = 0
          this.pagination.totalPages = 0
        })
        .finally(() => {
          this.loading = false
        })
    },

    /**
     * 计算分页
     */
    calculatePagination() {
      const maxVisiblePages = 7
      let startPage = Math.max(1, this.pagination.currentPage - Math.floor(maxVisiblePages / 2))
      let endPage = Math.min(this.pagination.totalPages, startPage + maxVisiblePages - 1)
      
      // 调整起始页，确保显示足够的页面
      if (endPage - startPage + 1 < maxVisiblePages) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1)
      }

      this.pagination.startPage = startPage
      this.pagination.endPage = endPage

      // 生成分页数组
      this.pagination.pages = []
      for (let i = startPage; i <= endPage; i++) {
        this.pagination.pages.push(i)
      }

      // 计算显示范围
      this.pagination.startIndex = (this.pagination.currentPage - 1) * this.pagination.pageSize + 1
      this.pagination.endIndex = Math.min(this.pagination.currentPage * this.pagination.pageSize, this.pagination.totalItems)
    },

    /**
     * 处理当前页码变化
     */
    handleCurrentChange(page) {
      if (page < 1 || page > this.pagination.totalPages || page === this.pagination.currentPage) {
        return
      }
      this.pagination.currentPage = page
      this.fetchInventoryData()
    },

    /**
     * 处理每页条数变化
     */
    handlePageSizeChange(pageSize) {
      this.pagination.pageSize = pageSize
      this.pagination.currentPage = 1
      this.fetchInventoryData()
    },

    /**
     * 格式化仓库显示
     */
    formatWarehouse(warehouseCode) {
      const warehouseMap = {
        'GH01': '加纳',
        'KE01': '肯尼亚',
        'UG01': '乌干达',
        'NG01': '尼日利亚',
        'PK02': '巴基斯坦'
      }
      return warehouseMap[warehouseCode] || warehouseCode || '-'
    },

    /**
     * 格式化货盘状态显示
     */
    formatPalletStatus(statusCode) {
      const statusMap = {
        '0': '否',
        '1': '是'
      }
      return statusMap[statusCode] || statusCode || ''
    },

    /**
     * 格式化产品货值
     */
    formatProductValue(value) {
      if (!value) return '-'
      return `${value}`
    },

    /**
     * 格式化产品定位列表
     */
    formatPositioningList(list) {
      if (!list) return []
      
      // 映射数字到中文标签
      const positioningMap = {
        2: '待定',
        4: '引流款',
        8: '稳定款'
      }
      
      let numbers = []
      
      // 如果已经是数组
      if (Array.isArray(list)) {
        numbers = list
      }
      // 如果是字符串，尝试解析
      else if (typeof list === 'string') {
        try {
          numbers = JSON.parse(list)
        } catch (e) {
          // 如果解析失败，尝试按逗号分割
          numbers = list.split(',').map(item => parseInt(item.trim())).filter(item => !isNaN(item))
        }
      }
      // 如果是单个数字
      else if (typeof list === 'number') {
        numbers = [list]
      }
      
      // 转换为中文标签
      return numbers.map(num => positioningMap[num] || num).filter(item => item)
    },

    /**
     * 打开编辑弹窗
     */
    openEditDialog(item) {
      this.currentEditItem = { ...item }
      
      // 初始化编辑表单
      this.editForm = {
        palletStatus: item.palletStatus ? item.palletStatus.toString() : '0',
        positioningList: []
      }
      
      // 解析产品定位数据
      if (item.positioningList) {
        let positioningData = []
        if (Array.isArray(item.positioningList)) {
          positioningData = item.positioningList
        } else if (typeof item.positioningList === 'string') {
          try {
            positioningData = JSON.parse(item.positioningList)
          } catch (e) {
            positioningData = item.positioningList.split(',').map(n => n.trim())
          }
        } else if (typeof item.positioningList === 'number') {
          positioningData = [item.positioningList]
        }
        
        // 转换为字符串格式
        this.editForm.positioningList = positioningData.map(n => n.toString()).filter(n => ['2', '4', '8'].includes(n))
      }
      
      this.showEditDialog = true
    },

    /**
     * 关闭编辑弹窗
     */
    closeEditDialog() {
      this.showEditDialog = false
      this.saving = false
      this.currentEditItem = {}
      this.editForm = {
        palletStatus: '',
        positioningList: []
      }
    },

    /**
     * 保存编辑
     */
    saveEdit() {
      this.saving = true
      
      const requestData = {
        id: this.currentEditItem.id,
        sku: this.currentEditItem.sku,
        warehouse: this.currentEditItem.warehouse,
        palletStatus: parseInt(this.editForm.palletStatus),
        positioningList: this.editForm.positioningList.map(n => parseInt(n))
      }
      
      this.axios.post('/data-serv/inventory/update', requestData)
        .then(response => {
          if (response.data.code === 0) {
            // 更新本地数据
            const index = this.inventoryList.findIndex(item => 
              item.sku === this.currentEditItem.sku && item.warehouse === this.currentEditItem.warehouse
            )
            
            if (index !== -1) {
              this.inventoryList[index] = {
                ...this.inventoryList[index],
                palletStatus: parseInt(this.editForm.palletStatus),
                positioningList: this.editForm.positioningList.map(n => parseInt(n))
              }
            }
            
            this.$message.success('保存成功')
            this.closeEditDialog()
          } else {
            throw new Error(response.data.message || '保存失败')
          }
        })
        .catch(error => {
          console.error('保存失败:', error)
          this.$message.error(error.message || '保存失败')
        })
        .finally(() => {
          this.saving = false
        })
    },

    /**
     * 处理图片加载错误
     */
    handleImageError(event) {
      event.target.style.display = 'none'
      event.target.nextSibling.style.display = 'inline'
    },

    /**
     * 格式化日期
     */
    formatDate(dateStr) {
      if (!dateStr) return '-'
      try {
        const date = new Date(dateStr)
        return date.toLocaleString('zh-CN', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit'
        })
      } catch (e) {
        return dateStr
      }
    },

    /**
     * 下载视频文件
     */
    downloadVideo(videoUrl) {
      // 确保URL是完整的
      let fullUrl = videoUrl;
      
      // 如果URL不是完整的http(s)链接，需要构建完整路径
      if (!videoUrl.startsWith('http://') && !videoUrl.startsWith('https://')) {
        // 根据当前环境确定基础URL
        if (process.env.NODE_ENV === 'development') {
          // 开发环境 - 使用代理服务
          fullUrl = videoUrl.startsWith('/') ? videoUrl : '/' + videoUrl;
          // 在开发环境中，链接会通过代理转发到后端服务
          window.open(fullUrl, '_blank');
        } else {
          // 生产环境 
          // 获取当前页面的完整URL作为基准
          const currentOrigin = window.location.origin;
          fullUrl = currentOrigin + (videoUrl.startsWith('/') ? videoUrl : '/' + videoUrl);
          window.open(fullUrl, '_blank');
        }
        return;
      }
      
      // 如果已经是完整URL，检查是否需要将HTTP转换为HTTPS
      try {
        const urlObj = new URL(videoUrl);
        const currentOrigin = window.location.origin;
        
        // 检查当前页面是否使用HTTPS，且视频URL使用HTTP
        if (window.location.protocol === 'https:' && urlObj.protocol === 'http:') {
          // 将HTTP转换为HTTPS
          urlObj.protocol = 'https:';
          fullUrl = urlObj.toString();
          console.log(`已自动将HTTP链接转换为HTTPS: ${videoUrl} -> ${fullUrl}`);
        }
        
        // 如果同源，直接打开
        if (urlObj.origin === currentOrigin) {
          window.open(fullUrl, '_blank');
          return;
        }
        
        // 如果不同源，同样直接打开（浏览器会处理安全策略）
        window.open(fullUrl, '_blank');
      } catch (e) {
        // URL解析失败，直接打开
        window.open(videoUrl, '_blank');
      }
    },

    /**
     * 滚动到页面顶部
     */
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    },

    /**
     * 滚动到页面底部
     */
    scrollToBottom() {
      window.scrollTo({
        top: document.documentElement.scrollHeight,
        behavior: 'smooth'
      })
    }
  }
}
</script>

<style scoped>
.inventory-list-container {
  padding: 20px;
  background-color: #f5f5f5;
  min-height: 100%;
  box-sizing: border-box;
}

.page-title {
  font-size: 24px;
  font-weight: bold;
  color: #303133;
  margin-bottom: 20px;
  text-align: center;
}

/* 查询表单样式 */
.search-form {
  background-color: white;
  padding: 20px;
  border-radius: 8px;
  margin-bottom: 20px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.search-row {
  display: flex;
  margin-bottom: 15px;
  gap: 15px;
}

.search-col {
  flex: 1;
  min-width: 0;
}

.search-button-col {
  flex: 0 0 100px;
  display: flex;
  align-items: flex-end;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
  font-weight: 500;
}

/* 表格样式 */
.table-container {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  overflow: hidden;
}

.table-container table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
}

.sticky-header {
  position: sticky;
  top: 0;
  background-color: #f5f7fa;
  z-index: 10;
}

.table-container th {
  text-align: center;
  padding: 12px 16px;
  font-weight: 600;
  color: #606266;
  border-bottom: 1px solid #ebeef5;
  font-size: 14px;
  white-space: normal;
  overflow: visible;
  text-overflow: clip;
  word-wrap: break-word;
  word-break: break-word;
}

.table-container td {
  padding: 12px 16px;
  border-bottom: 1px solid #ebeef5;
  color: #606266;
  font-size: 14px;
  word-wrap: break-word;
  word-break: break-word;
}

.table-container tr:hover {
  background-color: #f5f7fa;
}

/* 产品图片样式 */
.product-image {
  width: 40px;
  height: 40px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}

.product-image:hover {
  transform: scale(1.5);
  transition: transform 0.3s ease;
  position: relative;
  z-index: 100;
}

/* 视频链接样式 */
.video-link {
  color: #409eff;
  cursor: pointer;
  text-decoration: underline;
}

.video-link:hover {
  color: #66b1ff;
}

/* 产品定位样式 */
.positioning-list {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
}

.position-tag {
  background-color: #f0f2f5;
  color: #606266;
  padding: 2px 6px;
  border-radius: 2px;
  font-size: 12px;
  white-space: nowrap;
}

/* 分页样式 */
.pagination-container {
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
  border-top: 1px solid #ebeef5;
}

.page-size-selector {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #606266;
}

.pagination-info {
  font-size: 14px;
  color: #606266;
}

/* 响应式设计 */
@media (max-width: 768px) {
  .inventory-list-container {
    padding: 10px;
  }

  .search-row {
    flex-direction: column;
    gap: 10px;
  }

  .search-col {
    flex: none;
  }

  .search-button-col {
    flex: none;
    align-items: stretch;
  }

  .table-container th,
  .table-container td {
    padding: 8px 12px;
    font-size: 12px;
  }

  .pagination-container {
    flex-direction: column;
    align-items: stretch;
    gap: 15px;
  }

  .page-size-selector {
    justify-content: center;
  }

  .pagination-info {
    text-align: center;
  }
}

@media (max-width: 480px) {
  .page-title {
    font-size: 20px;
  }

  .search-form {
    padding: 15px;
  }

  .table-container th,
  .table-container td {
    padding: 6px 8px;
    font-size: 11px;
  }
}

/* 悬浮滚动按钮样式 */
.scroll-buttons {
  position: fixed;
  right: 30px;
  bottom: 50px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 1000;
}

.scroll-btn {
  width: 56px;
  height: 56px;
  border-radius: 50%;
  border: none;
  background-color: #909399;
  color: white;
  cursor: pointer;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
}

.scroll-btn .el-icon-arrow-up,
.scroll-btn .el-icon-arrow-down {
  font-size: 24px;
  color: white;
}

.scroll-btn:hover {
  background-color: #a6a9ad;
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(0, 0, 0, 0.2);
}

.scroll-btn:active {
  transform: translateY(0);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* 响应式设计 - 移动端隐藏悬浮按钮 */
@media (max-width: 768px) {
  .scroll-buttons {
    display: none;
  }
}

/* 编辑弹窗样式 */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2000;
}

.dialog-content {
  background-color: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

.dialog-header {
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.dialog-header h3 {
  margin: 0;
  font-size: 18px;
}

.close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #999;
}

.close-btn:hover {
  color: #666;
}

.dialog-body {
  padding: 20px;
  max-height: 60vh;
  overflow-y: auto;
}

.edit-form {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.edit-form .form-group {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.edit-form .form-group label {
  font-size: 14px;
  color: #606266;
  font-weight: 500;
}

.dialog-footer {
  padding: 16px 20px;
  border-top: 1px solid #f0f0f0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.dialog-footer button {
  padding: 6px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  border: 1px solid #d9d9d9;
  background-color: white;
  color: #666;
}

.dialog-footer button[type="primary"] {
  background-color: #409eff;
  border-color: #409eff;
  color: white;
}

.dialog-footer button:hover:not(:disabled) {
  border-color: #40a9ff;
  color: #40a9ff;
}

.dialog-footer button[type="primary"]:hover:not(:disabled) {
  background-color: #66b1ff;
  border-color: #66b1ff;
  color: white;
}

.dialog-footer button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
</style>